// extracted by mini-css-extract-plugin
export var originalPrice = "_vo-0";